module.exports = __webpack_public_path__ + "img/ring_0_0_0_0@3x.cc7b712c.png";